import React from 'react'
import CustomDivider from './CustomDivider'
import { Box, Typography } from '@mui/material'
import { Constants } from '../constants'
import useResponsive from './Responsive'

export const ImgText = ({ text, sx, variant = "h1", center = false }) => {
  return (
    <Typography
      variant={variant}
      mt={1}
      sx={{
        backgroundImage: `url(${Constants.customImages.TextBgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: "bold",
        display: "inline-block",
        width: center ? "100%" : "auto",
        textAlign: center ? "center" : "left", // ✅ center text if prop is true
        ...sx,
      }}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
};


const Heading = ({ Heading, SubHeading, RightContent, mb, center }) => {
  const isSmallScreen = useResponsive("sm");

  return (
    <Box sx={{ mb: mb ?? 5 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          pr: { xs: 0, lg: 5 },
        }}
      >
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography
            variant="body1"
            sx={{ color: "red.main" }}
            dangerouslySetInnerHTML={{ __html: SubHeading }}
            textAlign={center ? "center" : "left"} // ✅ conditional
          />

          {!isSmallScreen && <ImgText text={Heading} center={center} />}
        </Box>

        <Box sx={{ flexShrink: 0, ml: 2 }}>{RightContent}</Box>
      </Box>

      {isSmallScreen && <ImgText text={Heading} sx={{ fontSize: "20px" }} center={center} />}

      <CustomDivider size={5} />
    </Box>
  );
};


export default Heading